import * as React from 'react';
import {
} from '@material-ui/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import type { IScannerDetails } from './ScannerInterfaces';
import { emptyScannerDetails } from '../../admin/adminHelpers';
import EditScanner from './EditScanner';

const Scanner: React.FC<unknown> = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const { scannerIdParam } = useParams();

  const [formValues, setFormValues] = React.useState<IScannerDetails>(emptyScannerDetails);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const [isEdit] = React.useState<boolean>(!!scannerIdParam);

  const fetcher = (url: string) => axios.get<IScannerDetails>(url)
    .then((result) => {
      setFormValues(result.data);
      return result.data;
    });

  useSWR<IScannerDetails, AxiosError>(
    scannerIdParam
      ? `/scanner/getScanner?scannerId=${scannerIdParam}`
      : null,
    (url) => fetcher(url),
  );

  const handleBackToAllScannersClicked = () => {
    navigate('/screenless-scanners');
  };

  const handleSaveBtnClicked = () => {
    if (formValues) {
      setIsFetching(true);

      axios.post('/scanner/upsert', {
        ScannerId: scannerIdParam,
        Name: formValues.name,
        SerialNumber: formValues.serialNumber,
        IpAddress: formValues.ipAddress,
        MacAddress: formValues.macAddress,
        Location: formValues.location.label,
      })
        .then(() => {
          if (!isEdit) {
            enqueueSnackbar(`Added scanner: ${formValues.name}.`);
          } else {
            enqueueSnackbar(`Updated scanner: ${formValues.name}.`);
          }
          navigate('/screenless-scanners');
        })
        .catch((error: AxiosError) => {
          if (error?.message) {
            enqueueSnackbar('Unable to save scanner data', { persist: false, variant: 'error' });
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  };

  return (
    <EditScanner
      backToAllScanners={handleBackToAllScannersClicked}
      formValues={formValues}
      isEdit={isEdit}
      handleSaveBtnClicked={handleSaveBtnClicked}
      isFetching={isFetching}
      setFormValues={setFormValues}
    />
  );
};

export default Scanner;
